import { useState,useEffect } from 'react';
import { Link,useNavigate } from 'react-router-dom';


  // Component หลัก
  export default function DormitoryLayout() {
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // ในการใช้งานจริงควรเริ่มที่ false
    const [username, setUsername ] = useState('Loading...');

    const getUsernameFromSession = () => {
      const session = localStorage.getItem('userSession');
      if (!session) return null;

      try {
        const user = JSON.parse(session);
        return user.username || 'User';
      } catch {
        return null;
      }
    };

    useEffect(() => {
      const username = getUsernameFromSession();

      if (!username) {
        localStorage.removeItem('userSession');
        navigate('/login');
        return;
      }
      setUsername(username);
    }, [navigate]);


  const handleLogout = async () => {
    const confirmLogout = window.confirm("คุณต้องการออกจากระบบใช่หรือไม่?");
    if (confirmLogout) {
      // --- ล้างข้อมูล Session ในเครื่อง ---
      localStorage.removeItem('userSession');
      localStorage.removeItem('rememberPassword'); // ถ้าไม่ต้องการให้จดจำรหัสผ่านหลัง logout
      navigate('/');
    }
  };
  return (
    <div className="flex flex-col font-sans text-gray-800 ">
      
      {/* --- 1. Navbar Section --- */}
      <header className="bg-white px-6 py-3 flex justify-between items-center shadow-sm relative z-20">
        

          <div className="flex items-start justify-center md:justify-start mb-2">
            <img 
              src="/logo.png" 
              alt="The Nexus Logo" 
              className="w-48 h-auto object-contain" 
            />
          </div>

        {/* User Profile & Dropdown */}
        <div className="relative">
          <button 
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center gap-2 text-gray-700 hover:text-black focus:outline-none border-b-2 border-transparent hover:border-gray-300 pb-1"
          >
            {/* User Icon */}
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            
            {/* Username placeholder */}
            <span className="font-medium text-lg uppercase border-b-2 border-[#0e4b3a]">{username}</span>
            
            {/* Chevron Down Icon */}
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {/* Dropdown Menu Items */}
          {isDropdownOpen && (
            <div className="absolute right-0 top-full mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg overflow-hidden z-30">
              <Link to="/homemain/profilesettings">
                <button className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 border-b border-gray-200 text-left">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  โปรไฟล์
                </button>
              </Link>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 text-left">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transform rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                ออกจากระบบ
              </button>
            </div>
          )}
        </div>
      </header>

      {/* --- 2. Sub-Header (Green Bar) --- */}
      <div className="bg-emerald-900 text-white py-2 px-6 shadow-md z-10">
        <div className="container mx-auto">
            <h1 className="text-xl font-medium tracking-wide">Dormitory</h1>
        </div>
      </div>

    </div>
  );
}